type GtagCommand =
  | ['event', string, Record<string, unknown>?]
  | ['config', string, Record<string, unknown>?]
  | ['js', Date];

type GtagFunction = (...args: GtagCommand) => void;

declare global {
  interface Window {
    gtag?: GtagFunction;
  }
}

const isProd = process.env.REACT_APP_STAGE === '1-0-0';

export const gaPageView = () => {
  if (!isProd) return;

  window.gtag?.('event', 'page_view', {
    page_path: window.location.pathname + window.location.search,
    page_location: window.location.href,
    page_title: document.title,
  });
};

export const gaEvent = (name: string, params?: Record<string, unknown>) => {
  if (!isProd) return;
  window.gtag?.('event', name, params);
};
